// There is a copy of this file in `packages/duet-ui/src/config/storybook/fonts-config/fonts.verge.ts
// Sharing the same file is currently not possible due to NextJS errors.
// Both files should stay consistent.

import localFont from "next/font/local";

const fkRomanStandard = localFont({
  src: [
    {
      path: "./fonts/FKRomanStandard/FKRomanStandard-Regular.woff2",
      weight: "400",
      style: "normal",
    },
    {
      path: "./fonts/FKRomanStandard/FKRomanStandard-Oblique.woff2",
      weight: "400",
      style: "italic",
    },
    {
      path: "./fonts/FKRomanStandard/FKRomanStandard-Bold.woff2",
      weight: "700",
      style: "normal",
    },
    {
      path: "./fonts/FKRomanStandard/FKRomanStandard-BoldOblique.woff2",
      weight: "700",
      style: "italic",
    },
  ],
  preload: false,
  variable: "--font-fkroman",
  fallback: ["Georgia", "serif"],
  display: "swap",
  adjustFontFallback: "Times New Roman",
});

const manuka = localFont({
  src: [
    {
      weight: "900",
      style: "normal",
      path: "./fonts/ManukaCondensed/ManukaCondensed-Black.woff2",
    },
  ],
  variable: "--font-manuka",
  fallback: ["Impact", "Helvetica", "sans-serif"],
  display: "swap",
});

const polySans = localFont({
  src: [
    {
      weight: "300",
      style: "normal",
      path: "./fonts/PolySans/PolySans-Slim.woff2",
    },
    {
      weight: "300",
      style: "italic",
      path: "./fonts/PolySans/PolySans-SlimItalic.woff2",
    },
    {
      weight: "400",
      style: "normal",
      path: "./fonts/PolySans/PolySans-Neutral.woff2",
    },
    {
      weight: "400",
      style: "italic",
      path: "./fonts/PolySans/PolySans-NeutralItalic.woff2",
    },
    {
      weight: "500",
      style: "normal",
      path: "./fonts/PolySans/PolySans-Median.woff2",
    },
    {
      weight: "500",
      style: "italic",
      path: "./fonts/PolySans/PolySans-MedianItalic.woff2",
    },
    {
      weight: "700",
      style: "normal",
      path: "./fonts/PolySans/PolySans-Bulky.woff2",
    },
    {
      weight: "700",
      style: "italic",
      path: "./fonts/PolySans/PolySans-BulkyItalic.woff2",
    },
  ],
  variable: "--font-polysans",
  fallback: ["Helvetica", "Arial", "sans-serif"],
  display: "swap",
});

const polySansMono = localFont({
  src: [
    {
      weight: "400",
      style: "normal",
      path: "./fonts/PolySans/PolySans-NeutralMono.woff2",
    },
    {
      weight: "400",
      style: "italic",
      path: "./fonts/PolySans/PolySans-NeutralMonoItalic.woff2",
    },
    {
      weight: "500",
      style: "normal",
      path: "./fonts/PolySans/PolySans-MedianMono.woff2",
    },
    {
      weight: "500",
      style: "italic",
      path: "./fonts/PolySans/PolySans-MedianMonoItalic.woff2",
    },
    {
      weight: "700",
      style: "normal",
      path: "./fonts/PolySans/PolySans-BulkyMono.woff2",
    },
    {
      weight: "700",
      style: "italic",
      path: "./fonts/PolySans/PolySans-BulkyMonoItalic.woff2",
    },
  ],
  preload: false,
  variable: "--font-polysans-mono",
  fallback: ["Courier New", "Courier", "monospace"],
  display: "swap",
});

export const fontVars = {
  "--font-fkroman": fkRomanStandard.style.fontFamily,
  "--font-manuka": manuka.style.fontFamily,
  "--font-polysans": polySans.style.fontFamily,
  "--font-polysans-mono": polySansMono.style.fontFamily,
};
